// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dropdown-type[data-v-4a5551ee]  .dropdown-toggle:after{top:-2px}#dropdown-type[data-v-4a5551ee]  .dropdown-menu{z-index:99}", ""]);
// Exports
module.exports = exports;
